import React, { useState, useEffect } from "react";
import {
  Input,
  Row,
  Col,
  Label,
  FormGroup,
  Button,
  Card,
} from "reactstrap";
import Center from "react-center";
import Select from "react-select";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";
import "assets/scss/plugins/forms/flatpickr/flatpickr.scss";
import Axios from "axios";
import { urlAPI, getUser, getToken } from "utility/Common";
import PrintKartuStok from "./component/PrintKartuStok";
import PrintRekapPersediaan from "./component/PrintRekapPersediaan";
import { useDispatch } from "react-redux";
import { handleActionLogout } from "redux/actions/auth/logoutActions";
import { useDebounce } from "use-debounce";

const initFilter = {
  unit: null,
  kodebarang: null,
  jenisbarang: null,
  fromdate: moment().format("YYYY-MM-DD"),
  untildate: moment().format("YYYY-MM-DD"),
};

export default function Index(props) {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState(initFilter);
  const [jenisLaporan, setJenisLaporan] = useState("rekap_persediaan");
  const [openKartuStok, setOpenKartuStok] = useState(false);
  const [openRekapPersediaan, setOpenRekapPersediaan] = useState(false);
  const [selectorUnit, setSelectorUnit] = useState([]);
  const [loadingSelectorUnit, setLoadingSelectorUnit] = useState(false);
  const [selectorBarang, setSelectorBarang] = useState([]);
  const [loadingSelectorBarang, setLoadingSelectorBarang] = useState(false);
  const [typingBarang, setTypingBarang] = useState("");
  const [typingDebounce] = useDebounce(typingBarang, 1000);
  const [isSemuaBarang, setIsSemuaBarang] = useState(true);

  const [selectSemuaBarang] = useState([
    { value: true, label: "Semua Barang" },
    { value: false, label: "Pilih Barang" },
  ]);

  const [selectorJenis] = useState([
    { value: "rekap_persediaan", label: "Rekap Persediaan" },
    { value: "kartu_stok", label: "Kartu Stok" },
  ]);

  const [selectorJenisBarang] = useState([
    { value: null, label: "SEMUA JENIS" },
    { value: 1, label: "1094 - BAHAN DAPUR" },
    { value: 2, label: "1095 - ALAT TULIS" },
    { value: 3, label: "1096 - LINEN" },
    { value: 4, label: "1097 - CETAKAN" },
    { value: 5, label: "1098 - CONSUMABLE STOCK" },
    { value: 6, label: "1099 - SOUVENIR RAWAT INAP" },
  ]);

  const fetchSelectorUnit = () => {
    Axios.get(
      urlAPI +
        "/v1/unitlayanan/data?params=" +
        JSON.stringify({ isSelector: true }),
      { headers: { Authorization: "Bearer " + getToken() } }
    )
      .then((response) => {
        if (response?.data?.result?.rows?.length !== 0) {
          const selectorTemp = response?.data?.result?.rows?.map((obj) => ({
            value: obj?.kodeunit,
            label:
              obj?.kodeunit === ""
                ? obj?.kodeunit
                : obj?.kodeunit + " | " + obj?.namaunit,
            name: obj?.namaunit,
          }));
          setSelectorUnit(selectorTemp);
        }
        setLoadingSelectorUnit(false);
      })
      .catch((err) => {
        setLoadingSelectorUnit(false);
        if (err.response?.statusText === "Unauthorized") {
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.data?.message,
          });
        }
      });
  };

  const fetchSelectorObat = (unit, jenisbarang) => {
    const kodeUnit = unit !== undefined ? unit : filter?.unit;
    const jenis = jenisbarang !== undefined ? jenisbarang : filter?.jenisbarang;

    if (!kodeUnit) {
      setSelectorBarang([]);
      setLoadingSelectorBarang(false);
      return;
    }

    Axios.get(
      urlAPI +
        "/v1/master_barang/selector?params=" +
        JSON.stringify({
          selectorType: "persediaanunit",
          kodeUnit: kodeUnit,
          typing: typingDebounce,
          jenisbarang: jenis ?? null,
        }),
      { headers: { Authorization: "Bearer " + getToken() } }
    )
      .then((response) => {
        if (response?.data?.result?.rows?.length > 0) {
          const selectorTemp = response?.data?.result?.rows?.map((obj) => ({
            value: obj?.KODEBARANG,
            label: obj?.KODEBARANG
              ? obj?.KODEBARANG + " | " + obj?.NAMABARANG
              : obj?.NAMABARANG,
            namabarang: obj?.NAMABARANG,
            satuandasar: obj?.SATUANDASAR,
            jenisobat: obj?.JENISBARANG,
            harga: Number(obj?.HARGA),
            stokminimal: obj?.STOKMINIMAL,
            diskon: Number(obj?.DISKON),
            hrata: Number(obj?.HRATA),
            jumlahstok: Number(obj?.JUMLAHSTOK),
          }));
          setSelectorBarang(selectorTemp);
        } else {
          setSelectorBarang([]);
        }
        setLoadingSelectorBarang(false);
      })
      .catch((err) => {
        setLoadingSelectorBarang(false);
        if (err.response?.statusText === "Unauthorized") {
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.data?.message,
          });
        }
      });
  };

  useEffect(() => {
    setLoadingSelectorUnit(true);
    fetchSelectorUnit();
  }, []);

  useEffect(() => {
    if (filter?.unit) {
      setLoadingSelectorBarang(true);
      fetchSelectorObat(filter?.unit, filter?.jenisbarang);
    }
  }, [typingDebounce]);

  return (
    <>
      <PrintKartuStok
        open={openKartuStok}
        filter={{
          ...filter,
          kodebarang: isSemuaBarang ? null : filter?.kodebarang,
          jenisbarang: filter?.jenisbarang ?? null,
        }}
        handleClose={() => setOpenKartuStok(false)}
      />
      <PrintRekapPersediaan
        open={openRekapPersediaan}
        filter={{
          unit: filter?.unit,
          kodebarang: isSemuaBarang ? null : filter?.kodebarang,
          jenisbarang: filter?.jenisbarang ?? null,
        }}
        handleClose={() => setOpenRekapPersediaan(false)}
      />
      <Center>
        <h1>
          <strong>Laporan SINF Persediaan Perunit Bulanan</strong>
        </h1>
      </Center>
      <br />
      <Card body>
        <Row>
          <Col lg="4" md="4" sm="12">
            <Center>
              <img
                src="/assets/img/goods-1.svg"
                className="img-responsive"
                style={{ width: "100%" }}
                alt="yo"
              />
            </Center>
          </Col>
          <Col lg="8" md="8" sm="12">
            <Row>
              <Col lg="12" md="12" sm="12">
                <FormGroup>
                  <Label>
                    <strong>Unit Layanan</strong>
                  </Label>
                  <Select
                    id="unit"
                    name="unit"
                    isLoading={loadingSelectorUnit}
                    options={selectorUnit}
                    value={
                      selectorUnit?.find(
                        (find) => find.value === filter?.unit
                      ) ?? null
                    }
                    onChange={(e) => {
                      const newUnit = e.value;
                      setFilter({
                        ...filter,
                        unit: newUnit,
                        kodebarang: null,
                        jenisbarang: null,
                      });
                      setLoadingSelectorBarang(true);
                      fetchSelectorObat(newUnit, null);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col lg="6" md="6" sm="12">
                <FormGroup>
                  <Label>
                    <strong>Jenis Laporan</strong>
                  </Label>
                  <Select
                    id="jenis"
                    name="jenis"
                    options={selectorJenis}
                    value={selectorJenis?.find(
                      (find) => find.value === jenisLaporan
                    )}
                    onChange={(e) => {
                      setJenisLaporan(e.value);
                      setFilter({ ...filter, kodebarang: null });
                    }}
                    isSearchable={false}
                  />
                </FormGroup>
              </Col>
                            {jenisLaporan === "kartu_stok" && (
                <Col lg="6" md="6" sm="12">
                  <FormGroup>
                    <Label>Tanggal</Label>
                    <Flatpickr
                      value={[filter?.fromdate, filter?.untildate]}
                      className="form-control"
                      options={{ mode: "range" }}
                      onChange={(event) =>
                        setFilter({
                          ...filter,
                          fromdate: event[0]
                            ? moment(event[0]).format("YYYY-MM-DD")
                            : null,
                          untildate: event[1]
                            ? moment(event[1]).format("YYYY-MM-DD")
                            : null,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
              )}
            </Row>

            <Row>


              <Col lg="6" md="6" sm="12">
                <FormGroup>
                  <Label>
                    <strong>Barang</strong>
                  </Label>
                  <Select
                    id="barangnya"
                    name="barangnya"
                    options={selectSemuaBarang}
                    value={selectSemuaBarang?.find(
                      (find) => find.value === isSemuaBarang
                    )}
                    onChange={(e) => {
                      setIsSemuaBarang(e.value);
                      if (e.value === true) {
                        setFilter((prev) => ({
                          ...prev,
                          kodebarang: null,
                        }));
                      }
                    }}
                    isSearchable={false}
                  />
                </FormGroup>
              </Col>

              <Col lg="6" md="6" sm="12">
                <FormGroup>
                  <Label>
                    <strong>Jenis Barang</strong>
                  </Label>
                  {filter?.unit === "" || filter?.unit === null ? (
                    <Input
                      type="text"
                      value="Pilih Unit Layanan Terlebih Dahulu"
                      disabled={true}
                    />
                  ) : (
                    <Select
                      id="jenisbarang"
                      name="jenisbarang"
                      options={selectorJenisBarang}
                      value={
                        selectorJenisBarang?.find(
                          (find) => find.value === filter?.jenisbarang
                        ) ?? selectorJenisBarang[0]
                      }
                      onChange={(e) => {
                        const newJenis = e ? e.value : null;
                        setFilter((prev) => ({
                          ...prev,
                          jenisbarang: newJenis,
                          kodebarang: null,
                        }));
                        setLoadingSelectorBarang(true);
                        fetchSelectorObat(filter?.unit, newJenis);
                      }}
                      isClearable
                    />
                  )}
                </FormGroup>
              </Col>

              {!isSemuaBarang && (
                <Col lg="12" md="12" sm="12">
                  <FormGroup>
                    <Label>
                      <strong>Pilih Barang</strong>
                    </Label>
                    {filter?.unit === "" || filter?.unit === null ? (
                      <Input
                        type="text"
                        value="Pilih Unit Layanan Terlebih Dahulu"
                        disabled={true}
                      />
                    ) : (
                      <Select
                        id="barang"
                        name="barang"
                        isLoading={loadingSelectorBarang}
                        options={selectorBarang}
                        onInputChange={(value) => {
                          setLoadingSelectorBarang(true);
                          setTypingBarang(value);
                        }}
                        value={
                          selectorBarang?.find(
                            (find) => find.value === filter?.kodebarang
                          ) ?? null
                        }
                        onChange={(e) => {
                          setFilter({
                            ...filter,
                            kodebarang: e ? e.value : null,
                          });
                        }}
                        isClearable
                      />
                    )}
                  </FormGroup>
                </Col>
              )}
            </Row>

            <br />
            <Button
              color="success"
              block={true}
              onClick={() => {
                if (jenisLaporan === "kartu_stok") {
                  setOpenKartuStok(true);
                } else {
                  setOpenRekapPersediaan(true);
                }
              }}
              disabled={
                jenisLaporan === "kartu_stok"
                  ? filter?.unit === null ||
                    (filter?.kodebarang === null &&
                      filter?.jenisbarang === null)
                  : filter?.unit === null
              }
            >
              Tampilkan Data
            </Button>
          </Col>
        </Row>
      </Card>
    </>
  );
}